module.exports = __webpack_public_path__ + "static/media/pt.72e2941b.jpeg";